
export const SaveView = async ({
    indexesToRaname,
    RenameInputValues,
    tempTabNames,
    widgetsData,
    multipleImages,
    storeTabIndexes,
    imagePosition,
    imageDimensions,
    tempImages,
    updatedImages,
    displayData,
    multipleDisplay,
    displayPosition,
    deviceData,
    multipleDevices,
    devicePosition,
    controllerData,
    multipleController,
    controllerPosition,
    ioData,
    multipleIO,
    ioPosition,
    flowMeterData,
    multipleFlowM,
    flowMPosition,
    energyMeterData,
    multipleEnergyM,
    energyMPosition,
    textData,
    multipleText,
    textPosition,
    textAlignVertically,
    textAlignHorizontally,
    motorData,
    multipleMotor,
    motorPosition,
    lineChartData,
    multipleLineCharts,
    lineChartPosition,
    pieChartData,
    multiplePieChart,
    pieChartPosition,
    toolbarChartData,
    multipleBarChart,
    barChartPosition,
    toolBarhistogramData,
    multipleHistogram,
    histogramPosition,
    gaugeData,
    multipleGauge,
    gaugePosition,
    startPoint,
    endPoint,
    setImages,
    progressBarData,
    multipleProgress,
    progressPosition,
    minimumVal,
    maximumVal,
    rotateBar,
    gridData,
    multipleGrid,
    gridPositions,
    toolBarTableData,
    multipleTable,
    tablePosition,
    tabIndexOverviewInfo,
    overviewInfoData,
    overviewInfoPosi,
    tabIndexOverviewGraph,
    overviewGraphData,
    overviewGraphPosi,
    overviewGraphDimension,
    tabIndexLiveDataGraph,
    liveGraphData,
    liveDataGraphPosi,
    liveDataGraphDimension,
    tabIndexLastDayTable,
    lastDayTableData,
    lastDayTablePosi,
    lastDayTableDimension,
    tabIndexLastDayGraph,
    lastDayGraphData,
    lastDayGraphPosi,
    lastDayGraphDimension,
    tabIndexDefaultGrid,
    defaultGridData,
    defaultGridPosi,
    defaultGridDimension,
    removeDuplicates,
    dispatch,
    addWidget,
    windowHeight,
    windowWidth,
    uniqueProjectId,
    toast,
    setUpdatedImages,
    setTempTabIndexDevices,
    setMultipleDevices,
    setTempTabIndexDisplay,
    setMultipleDisplay,
    setTempTabIndexController,
    setMultipleController,
    setTempTabIndexIO,
    setMultipleIO,
    updatedMultipleIO,
    setTempTabIndexFlowM,
    setMultipleFlowM,
    setTempTabIndexEnergyM,
    setMultipleEnergyM,
    setTempTabIndexMotor,
    setMultipleMotor,
    setTempTabIndexText,
    setMultipleText,
    setTempTabIndexLineChart,
    setMultipleLineCharts,
    setTempTabIndexPieChart,
    setMultiplePieChart,
    setTempTabIndexBarChart,
    setMultipleBarChart,
    setTempTabIndexHistogram,
    setMultipleHistogram,
    setTempTabIndexGauge,
    setMultipleGauge,
    setTempTabIndexProgress,
    setMultipleProgress,
    setTempTabIndexGrid,
    setMultipleGrid,
    setTempTabIndexTable,
    setMultipleTable,
    setTabIndexImages,
    setTabIndexDevices,
    setUpdatedTabIndexDevices,
    setTabIndexDisplay,
    setUpdatedTabIndexDisplay,
    setTabIndexController,
    setUpdatedTabIndexController,
    setTabIndexIO,
    setUpdatedTabIndexIO,
    setTabIndexFlowM,
    setUpdatedTabIndexFlowM,
    setTabIndexEnergyM,
    setUpdatedTabIndexEnergyM,
    setTabIndexMotor,
    setUpdatedTabIndexMotor,
    setTabIndexText,
    setUpdatedTabIndexText,
    setTabIndexLineChart,
    setUpdatedTabIndexLineChart,
    setTabIndexPieChart,
    setUpdatedTabIndexPieChart,
    setTabIndexBarChart,
    setUpdatedTabIndexBarChart,
    setTabIndexHistogram,
    setUpdatedTabIndexHistogram,
    setTabIndexGauge,
    setUpdatedTabIndexGauge,
    setTabIndexProgress,
    setUpdatedTabIndexProgress,
    setTabIndexGrid,
    setUpdatedTabIndexGrid,
    setTabIndexTable,
    setUpdatedTabIndexTable,
    setTabIndexOverviewGraph,
    setTabIndexOverviewInfo,
    setTabIndexLiveDataGraph,
    setTabIndexLastDayTable,
    setTabIndexLastDayGraph,
    setTabIndexDefaultGrid,
    multipleCircularProgress,
    setMultipleCircularProgress,
    setTempTabIndexCircularProgress,
    circularProgressData,
    circularProgressPosition,
    setTabIndexCircularProgress,
    updatedMultipleCircularProgress,
    updatedMultipleDisplay,
    updatedMultipleText,
    updatedMultipleMotor,
    updatedMultipleLineChart,
    updatedMultiplePieChart,
    updatedMultipleBarChart,
    updatedMultipleHistogram,
    updatedMultipleGauge,
    updatedMultipleProgress,
    updatedMultipleGrid,
    updatedMultipleTable,

    setTabIndexDoughnut,
    setUpdatedTabIndexDoughnut,
    doughnutData,
    setTempTabIndexDoughnut,
    multipleDoughnut,
    setMultipleDoughnut,
    doughnutPosition,
    updatedMultipleDoughnut,
    linesData,
    multipleLines,
    setTempTabIndexLines,
    setMultipleLines,
    setTabIndexLines,
    setUpdatedTabIndexLines,
    updatedMultipleSquare,
    squarePosition,
    multipleSquare,
    squareData,
    setTabIndexSquare,
    setUpdatedTabIndexSquare,
    setMultipleSquare,
    setTempTabIndexSquare,
    setUpdatedTabIndexCircle,
    setTabIndexCircle,
    setTempTabIndexCircle,
    circleData,
    updatedMultipleCircle,
    circlePosition,
    setMultipleCircle,
    multipleCircle,
    polygoneData,
    multiplePolygone,
    setMultiplePolygone,
    updatedMultiplePolygone,
    polygonePosition,
    setTabIndexPolygone,
    setUpdatedTabIndexPolygone,
    setTempTabIndexPolygone,
    pipeData,
    multiplePipe,
    setMultiplePipe,
    updatedMultiplePipe,
    pipePosition,
    setTabIndexPipe,
    setUpdatedTabIndexPipe,
    setTempTabIndexPipe,
    switchData,
    multipleSwitch,
    setMultipleSwitch,
    switchPosition,
    setTabIndexSwitch,
    setUpdatedTabIndexSwitch,
    setTempTabIndexSwitch,
    checkboxData,
    multipleCheckbox,
    setMultipleCheckbox,
    checkboxPosition,
    setTabIndexCheckbox,
    setUpdatedTabIndexCheckbox,
    setTempTabIndexCheckbox,
    radioData,
    multipleRadio,
    setMultipleRadio,
    radioPosition,
    setTabIndexRadio,
    setUpdatedTabIndexRadio,
    setTempTabIndexRadio,
    updatedMultipleRadio,
    sliderData,
    multipleSlider,
    setMultipleSlider,
    sliderPosition,
    setTabIndexSlider,
    setUpdatedTabIndexSlider,
    setTempTabIndexSlider,
    updatedMultipleSlider,
    lampData,
    multipleLamp,
    setMultipleLamp,
    lampPosition,
    setTabIndexLamp,
    setUpdatedTabIndexLamp,
    setTempTabIndexLamp,
    updatedMultipleLamp,
    pushData,
    multiplePush,
    setMultiplePush,
    pushPosition,
    setTabIndexPush,
    setUpdatedTabIndexPush,
    setTempTabIndexPush,
    updatedMultiplePush,
    linkData,
    multipleLink,
    setMultipleLink,
    linkPosition,
    setTabIndexLink,
    setUpdatedTabIndexLink,
    setTempTabIndexLink,
    updatedMultipleLink,
    clockData,
    multipleClock,
    setMultipleClock,
    clockPosition,
    setTabIndexClock,
    setUpdatedTabIndexClock,
    setTempTabIndexClock,
    updatedMultipleClock,
    linePosition,
    containerDimensions,
    onText,
    offText,
    onColor,
    offColor,



}) => {
    // Fetch Request to Add New Tab/ Add New Image/ Add Update Image Position

    {
        indexesToRaname.length > 0 &&
            RenameInputValues.forEach((inputValue, index) => {
                tempTabNames[indexesToRaname[index]] = inputValue;
            });
    }

    // storing new images/devices/charts to previous data   
    widgetsData = multipleImages.map((image, imgIndex) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        tabIndex: storeTabIndexes[imgIndex],
        name: image.name,
        deviceType: image.deviceType,
        x: imagePosition.length > 0 ? imagePosition[imgIndex]?.x : 0,
        y: imagePosition.length > 0 ? imagePosition[imgIndex]?.y + 40 : 0,
        width:
            imageDimensions.length > 0 ? imageDimensions[imgIndex].width : "100px",
        height:
            imageDimensions.length > 0 ? imageDimensions[imgIndex].height : "100px",
        hideChannel: image.hideChannel ? image.hideChannel : "",
        hideValue: image.hideValue ? image.hideValue : "",
        conditionValue: image.conditionValue ? image.conditionValue : {},
        moveValue: image.moveValue ? image.moveValue : {},
        horizontalMoveChannel: image.horizontalMoveChannel ? image.horizontalMoveChannel : "",
        verticalMoveChannel: image.verticalMoveChannel ? image.verticalMoveChannel : "",
        zIndex: image?.zIndex ?? 1
    }));

    widgetsData.map((item) => tempImages.push(item));
    widgetsData.map((item) => updatedImages.push(item));

    displayData = multipleDisplay.slice(1).map((device, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleDisplay[index + 1].deviceName,
        deviceType: multipleDisplay[index + 1].type,
        x: displayPosition.length > 0 ? displayPosition[index + 1]?.x : 0,
        y: displayPosition.length > 0 ? displayPosition[index + 1]?.y + 40 : 0,
        tabIndex: device.tabIndex,
        width: updatedMultipleDisplay[index + 1].width ? updatedMultipleDisplay[index + 1].width : null,
        height: updatedMultipleDisplay[index + 1].height ? updatedMultipleDisplay[index + 1].height : null,
        channelName: {
            PV: device.pvChannel ? device.pvChannel : "",
            SV: "",
        },
        hideChannel: device.hideChannel ? device.hideChannel : "",
        hideValue: device.hideValue ? device.hideValue : "",
        bgColor: device.bgColor ? device.bgColor : "#542A2A",
        textColor: device.textColor ? device.textColor : "#D90211",
        fontSize: device.fontSize ? device.fontSize : "30",
        zIndex: device?.zIndex ? device?.zIndex : 1
    }));

    displayData.map((item) => tempImages.push(item));
    displayData.map((item) => updatedImages.push(item));


    deviceData = multipleDevices.slice(1).map((device, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleDevices[index + 1].deviceName,
        deviceType: multipleDevices[index + 1].type,
        x: devicePosition.length > 0 ? devicePosition[index + 1]?.x : 0,
        y: devicePosition.length > 0 ? devicePosition[index + 1]?.y + 40 : 0,
        tabIndex: device.tabIndex,
        channelName: {
            PV: device.pvChannel ? device.pvChannel : "",
            SV: "",
        },
        unit: device.unit !== "" ? device.unit : "--",
        zIndex: device?.zIndex ? device?.zIndex : 1
    }));

    deviceData.map((item) => tempImages.push(item));
    deviceData.map((item) => updatedImages.push(item));

    controllerData = multipleController.slice(1).map((controller, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleController[index + 1].deviceName,
        deviceType: multipleController[index + 1].type,
        x: controllerPosition.length > 0 ? controllerPosition[index + 1]?.x : 0,
        y: controllerPosition.length > 0 ? controllerPosition[index + 1]?.y + 40 : 0,
        tabIndex: controller.tabIndex,
        channelName: {
            PV: controller.pvChannel ? controller.pvChannel : "",
            SV: controller.svChannel ? controller.svChannel : "",
        },
        unit: controller.unit !== "" ? controller.unit : "--",
        zIndex: controller?.zIndex ? controller?.zIndex : 1
    }));

    controllerData.map((item) => tempImages.push(item));
    controllerData.map((item) => updatedImages.push(item));

    ioData = multipleIO.slice(1).map((IO, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleIO[index + 1].deviceName,
        deviceType: multipleIO[index + 1].type,
        tabIndex: IO.tabIndex,
        x: ioPosition.length > 0 ? ioPosition[index + 1]?.x : 0,
        y: ioPosition.length > 0 ? ioPosition[index + 1]?.y + 40 : 0,
        width: updatedMultipleIO[index + 1].width ? updatedMultipleIO[index + 1].width : null,
        height: updatedMultipleIO[index + 1].height ? updatedMultipleIO[index + 1].height : null,
        on: 0,
        channelName: {
            PV: IO.pvChannel ? IO.pvChannel : "",
            SV: IO.svChannel ? IO.svChannel : "",
        },
        onText: IO.onText ? IO.onText : "ON",
        offText: IO.offText ? IO.offText : "OFF",
        onColor: IO.onColor ? IO.onColor : "#00FF00",
        offColor: IO.offColor ? IO.offColor : "#FF0000",
        fontSize: IO.fontSize ? IO.fontSize : "14",
        zIndex: IO?.zIndex ? IO?.zIndex : 1,

        hideChannel: IO.hideChannel ? IO.hideChannel : "",
        hideValue: IO.hideValue ? IO.hideValue : "",
        conditionValue: IO.conditionValue ? IO.conditionValue : {},
        moveValue: IO.moveValue ? IO.moveValue : {},
        horizontalMoveChannel: IO.horizontalMoveChannel ? IO.horizontalMoveChannel : "",
        verticalMoveChannel: IO.verticalMoveChannel ? IO.verticalMoveChannel : "",

    }));

    ioData.map((item) => tempImages.push(item));
    ioData.map((item) => updatedImages.push(item));

    flowMeterData = multipleFlowM.slice(1).map((flowMeter, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleFlowM[index + 1].deviceName,
        deviceType: multipleFlowM[index + 1].type,
        tabIndex: flowMeter.tabIndex,
        x: flowMPosition.length > 0 ? flowMPosition[index + 1]?.x : 0,
        y: flowMPosition.length > 0 ? flowMPosition[index + 1]?.y + 40 : 0,
        channelName: {
            PV: flowMeter.pvChannel ? flowMeter.pvChannel : "",
            SV: flowMeter.svChannel ? flowMeter.svChannel : "",
        },
        unitPv: flowMeter.unitPv !== "" ? flowMeter.unitPv : "--",
        unitSv: flowMeter.unitSv !== "" ? flowMeter.unitSv : "--",
        zIndex: flowMeter?.zIndex ? flowMeter?.zIndex : 1
    }));

    flowMeterData.map((item) => tempImages.push(item));
    flowMeterData.map((item) => updatedImages.push(item));

    energyMeterData = multipleEnergyM.slice(1).map((energyMeter, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleEnergyM[index + 1].deviceName,
        deviceType: multipleEnergyM[index + 1].type,
        tabIndex: energyMeter.tabIndex,
        x: energyMPosition.length > 0 ? energyMPosition[index + 1]?.x : 0,
        y: energyMPosition.length > 0 ? energyMPosition[index + 1]?.y + 40 : 0,
        channelName: {
            PV: energyMeter.pvChannel ? energyMeter.pvChannel : "",
            SV: energyMeter.svChannel ? energyMeter.svChannel : "",
            SV2: energyMeter.svChannel2 ? energyMeter.svChannel2 : "",
            SV3: energyMeter.svChannel3 ? energyMeter.svChannel3 : "",
            SV4: energyMeter.svChannel4 ? energyMeter.svChannel4 : "",
        },
        unitPv: energyMeter.unitPv !== "" ? energyMeter.unitPv : "--",
        unitSv: energyMeter.unitSv !== "" ? energyMeter.unitSv : "--",
        unitSv2: energyMeter.unitSv2 !== "" ? energyMeter.unitSv2 : "--",
        unitSv3: energyMeter.unitSv3 !== "" ? energyMeter.unitSv3 : "--",
        zIndex: energyMeter?.zIndex ? energyMeter?.zIndex : 1
    }));

    energyMeterData.map((item) => tempImages.push(item));
    energyMeterData.map((item) => updatedImages.push(item));

    textData = multipleText.slice(1).map((text, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: text.deviceName,
        deviceType: text.type,
        tabIndex: text.tabIndex,
        text: text.text ? text.text : "Text",
        x: textPosition.length > 0 ? textPosition[index + 1]?.x : 0,
        y: textPosition.length > 0 ? textPosition[index + 1]?.y + 40 : 0,
        bgColor: text.bgColor ? text.bgColor : "#000000",
        textColor: text.textColor ? text.textColor : "#ffffff",
        fontSize: text.fontSize ? text.fontSize : "30",
        width: updatedMultipleText[index + 1].width ? updatedMultipleText[index + 1].width : null,
        height: updatedMultipleText[index + 1].height ? updatedMultipleText[index + 1].height : null,
        alignVertically: text.alignVertically ? text.alignVertically : textAlignVertically,
        alignHorizontally: text.alignHorizontally ? text.alignHorizontally : textAlignHorizontally,
        channelName: {
            PV: text.pvChannel ? text.pvChannel : "",
            SV: "",
        },
        isTransparent: text?.isTransparent ? text?.isTransparent : false,
        zIndex: text?.zIndex ? text?.zIndex : 1
    }))

    textData.map((item) => tempImages.push(item));
    textData.map((item) => updatedImages.push(item));

    motorData = multipleMotor.slice(1).map((motor, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: motor.image,
        deviceType: motor.type,
        tabIndex: motor.tabIndex,
        x: motorPosition.length > 0 ? motorPosition[index + 1]?.x : 0,
        y: motorPosition.length > 0 ? motorPosition[index + 1]?.y + 40 : 0,
        channelName: {
            PV: motor.pvChannel ? motor.pvChannel : "",
            SV: "",
        },
        hideChannel: motor?.hideChannel ? motor?.hideChannel : "",
        hideValue: motor?.hideValue ? motor?.hideValue : "",
        width: updatedMultipleMotor[index + 1].width ? updatedMultipleMotor[index + 1].width : null,
        height: updatedMultipleMotor[index + 1].height ? updatedMultipleMotor[index + 1].height : null,
        on: motor.on ? motor.on : 0,
        zIndex: motor?.zIndex ? motor?.zIndex : 1
    }))

    motorData.map((item) => tempImages.push(item));
    motorData.map((item) => updatedImages.push(item));


    lineChartData = multipleLineCharts.slice(1).map((chart, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleLineCharts[index + 1].deviceName,
        deviceType: multipleLineCharts[index + 1].type,
        tabIndex: chart.tabIndex,
        x: lineChartPosition.length > 0 ? lineChartPosition[index + 1]?.x : 0,
        y: lineChartPosition.length > 0 ? lineChartPosition[index + 1]?.y + 40 : 0,
        chartChannel: chart.chartChannel ? chart.chartChannel : [],
        width: updatedMultipleLineChart[index + 1].width ? updatedMultipleLineChart[index + 1].width : null,
        height: updatedMultipleLineChart[index + 1].height ? updatedMultipleLineChart[index + 1].height : null,
        hour: chart.hour ? chart.hour : 0,
        minute: chart.minute ? chart.minute : 0,
        zIndex: chart?.zIndex ? chart?.zIndex : 1,
        lineStyle: chart?.lineStyle ? chart?.lineStyle : "Line",
        isCurveLine: chart?.isCurveLine ? chart?.isCurveLine : false,
        isSteppedLine: chart?.isSteppedLine ? chart?.isSteppedLine : false,
        minY: chart?.minY,
        maxY: chart?.maxY,
        xInterval: chart?.xInterval,
        yInterval: chart?.yInterval
    }));

    lineChartData.map((item) => tempImages.push(item));
    lineChartData.map((item) => updatedImages.push(item));


    pieChartData = multiplePieChart.slice(1).map((chart, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multiplePieChart[index + 1].deviceName,
        deviceType: multiplePieChart[index + 1].type,
        tabIndex: chart.tabIndex,
        x: pieChartPosition.length > 0 ? pieChartPosition[index + 1]?.x : 0,
        y: pieChartPosition.length > 0 ? pieChartPosition[index + 1]?.y + 40 : 0,
        chartChannel: chart.chartChannel ? chart.chartChannel : [],
        width: updatedMultiplePieChart[index + 1].width ? updatedMultiplePieChart[index + 1].width : null,
        height: updatedMultiplePieChart[index + 1].height ? updatedMultiplePieChart[index + 1].height : null,
        zIndex: chart?.zIndex ? chart?.zIndex : 1

    }));

    pieChartData.map((item) => tempImages.push(item));
    pieChartData.map((item) => updatedImages.push(item));

    toolbarChartData = multipleBarChart.slice(1).map((chart, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleBarChart[index + 1].deviceName,
        deviceType: multipleBarChart[index + 1].type,
        tabIndex: chart.tabIndex,
        x: barChartPosition.length > 0 ? barChartPosition[index + 1]?.x : 0,
        y: barChartPosition.length > 0 ? barChartPosition[index + 1]?.y + 40 : 0,
        chartChannel: chart.chartChannel ? chart.chartChannel : [],
        width: updatedMultipleBarChart[index + 1].width ? updatedMultipleBarChart[index + 1].width : null,
        height: updatedMultipleBarChart[index + 1].width ? updatedMultipleBarChart[index + 1].width : null,
        zIndex: chart?.zIndex ? chart?.zIndex : 1

    }));

    toolbarChartData.map((item) => tempImages.push(item));
    toolbarChartData.map((item) => updatedImages.push(item));

    toolBarhistogramData = multipleHistogram.slice(1).map((chart, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleHistogram[index + 1].deviceName,
        deviceType: multipleHistogram[index + 1].type,
        tabIndex: chart.tabIndex,
        x: histogramPosition.length > 0 ? histogramPosition[index + 1]?.x : 0,
        y: histogramPosition.length > 0 ? histogramPosition[index + 1]?.y + 40 : 0,
        chartChannel: chart.chartChannel ? chart.chartChannel : [],
        width: updatedMultipleHistogram[index + 1].width ? updatedMultipleHistogram[index + 1].width : null,
        height: updatedMultipleHistogram[index + 1].width ? updatedMultipleHistogram[index + 1].width : null,
        hour: chart.hour ? chart.hour : 0,
        minute: chart.minute ? chart.minute : 0,
        zIndex: chart?.zIndex ? chart?.zIndex : 1

    }));

    toolBarhistogramData.map((item) => tempImages.push(item));
    toolBarhistogramData.map((item) => updatedImages.push(item));


    gaugeData = multipleGauge.slice(1).map((chart, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleGauge[index + 1].deviceName,
        deviceType: multipleGauge[index + 1].type,
        tabIndex: chart.tabIndex,
        x: gaugePosition.length > 0 ? gaugePosition[index + 1]?.x : 0,
        y: gaugePosition.length > 0 ? gaugePosition[index + 1]?.y + 40 : 0,
        chartChannel: chart.chartChannel ? chart.chartChannel : [],
        minVal: startPoint.length > 0 ? startPoint[index] : 0,
        maxVal: endPoint.length > 0 ? endPoint[index] : 100,
        width: updatedMultipleGauge[index + 1].width ? updatedMultipleGauge[index + 1].width : null,
        height: updatedMultipleGauge[index + 1].width ? updatedMultipleGauge[index + 1].width : null,
        fontSize: chart.fontSize ? chart.fontSize : "60",
        zIndex: chart?.zIndex ? chart?.zIndex : 1

    }));

    gaugeData.map((item) => tempImages.push(item));
    gaugeData.map((item) => updatedImages.push(item));


    progressBarData = multipleProgress.slice(1).map((progressBar, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleProgress[index + 1].deviceName,
        deviceType: multipleProgress[index + 1].type,
        tabIndex: progressBar.tabIndex,
        x: progressPosition.length > 0 ? progressPosition[index + 1]?.x : 0,
        y: progressPosition.length > 0 ? progressPosition[index + 1]?.y + 40 : 0,
        chartChannel: progressBar.chartChannel ? progressBar.chartChannel : [],
        minVal: minimumVal.length > 0 ? minimumVal[index] : 0,
        maxVal: maximumVal.length > 0 ? maximumVal[index] : 100,
        rotate: rotateBar,
        width: updatedMultipleProgress[index + 1].width ? updatedMultipleProgress[index + 1].width : null,
        height: updatedMultipleProgress[index + 1].height ? updatedMultipleProgress[index + 1].height : null,
        fontSize: progressBar.fontSize ? progressBar.fontSize : "56",
        bgColor: progressBar.bgColor ? progressBar.bgColor : null,
        zIndex: progressBar?.zIndex ? progressBar?.zIndex : 1

    }));

    progressBarData.map((item) => tempImages.push(item));
    progressBarData.map((item) => updatedImages.push(item));

    gridData = multipleGrid.slice(1).map((grid, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleGrid[index + 1].deviceName,
        deviceType: multipleGrid[index + 1].type,
        tabIndex: grid.tabIndex,
        x: gridPositions.length > 0 ? gridPositions[index + 1]?.x : 0,
        y: gridPositions.length > 0 ? gridPositions[index + 1]?.y + 40 : 0,
        chartChannel: grid.chartChannel ? grid.chartChannel : [],
        width: updatedMultipleGrid[index + 1].width ? updatedMultipleGrid[index + 1].width : null,
        height: updatedMultipleGrid[index + 1].height ? updatedMultipleGrid[index + 1].height : null,
        zIndex: grid?.zIndex ? grid?.zIndex : 1

    }));

    gridData.map((item) => tempImages.push(item));
    gridData.map((item) => updatedImages.push(item));


    toolBarTableData = multipleTable.slice(1).map((table, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleTable[index + 1].deviceName,
        deviceType: multipleTable[index + 1].type,
        tabIndex: table.tabIndex,
        x: tablePosition.length > 0 ? tablePosition[index + 1]?.x : 0,
        y: tablePosition.length > 0 ? tablePosition[index + 1]?.y + 40 : 0,
        width: updatedMultipleTable[index + 1].width ? updatedMultipleTable[index + 1].width : null,
        height: updatedMultipleTable[index + 1].width ? updatedMultipleTable[index + 1].width : null,
        chartChannel: table.chartChannel ? table.chartChannel : [],
        column: table.column ? table.column : null,
        zIndex: table?.zIndex ? table?.zIndex : 1

    }));

    toolBarTableData.map((item) => tempImages.push(item));
    toolBarTableData.map((item) => updatedImages.push(item));

    circularProgressData = multipleCircularProgress.slice(1).map((widget, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleCircularProgress[index + 1].deviceName,
        deviceType: multipleCircularProgress[index + 1].type,
        tabIndex: widget.tabIndex,
        x: circularProgressPosition.length > 0 ? circularProgressPosition[index + 1]?.x : 0,
        y: circularProgressPosition.length > 0 ? circularProgressPosition[index + 1]?.y + 40 : 0,
        width: updatedMultipleCircularProgress[index + 1]?.width ? updatedMultipleCircularProgress[index + 1]?.width : null,
        height: updatedMultipleCircularProgress[index + 1]?.height ? updatedMultipleCircularProgress[index + 1]?.height : null,
        chartChannel: widget.chartChannel ? widget.chartChannel : [],
        maxVal: updatedMultipleCircularProgress[index + 1].maxVal ? updatedMultipleCircularProgress[index + 1].maxVal : 1000,
        zIndex: widget?.zIndex ? widget?.zIndex : 1

    }));

    circularProgressData.map((item) => tempImages.push(item));
    circularProgressData.map((item) => updatedImages.push(item));

    doughnutData = multipleDoughnut.slice(1).map((chart, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleDoughnut[index + 1].deviceName,
        deviceType: multipleDoughnut[index + 1].type,
        tabIndex: chart.tabIndex,
        x: doughnutPosition.length > 0 ? doughnutPosition[index + 1]?.x : 0,
        y: doughnutPosition.length > 0 ? doughnutPosition[index + 1]?.y + 40 : 0,
        chartChannel: chart.chartChannel ? chart.chartChannel : [],
        width: updatedMultipleDoughnut[index + 1].width ? updatedMultipleDoughnut[index + 1].width : null,
        height: updatedMultipleDoughnut[index + 1].height ? updatedMultipleDoughnut[index + 1].height : null,
        zIndex: chart?.zIndex ? chart?.zIndex : 1

    }));

    doughnutData.map((item) => tempImages.push(item));
    doughnutData.map((item) => updatedImages.push(item));



    linesData = multipleLines.slice(1).map((line, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleLines[index + 1].deviceName,
        deviceType: multipleLines[index + 1].type,
        tabIndex: line.tabIndex,
        width: line?.width,
        height: line?.height,
        length: line?.length,
        deltaX: line?.deltaX,
        deltaY: line?.deltaY,
        angle: line?.angle,
        x: linePosition.length > 0 ? linePosition[index + 1]?.x : line?.x,
        y: linePosition.length > 0 ? linePosition[index + 1]?.y : line?.y,
        zIndex: line?.zIndex ? line?.zIndex : 1,
        hideChannel: line.hideChannel ? line.hideChannel : "",
        hideValue: line.hideValue ? line.hideValue : "",
        bgColor: line.bgColor ? line.bgColor : "black",
        conditionValue: line.conditionValue ? line.conditionValue : {},
        moveValue: line.moveValue ? line.moveValue : {},
        horizontalMoveChannel: line.horizontalMoveChannel ? line.horizontalMoveChannel : "",
        verticalMoveChannel: line.verticalMoveChannel ? line.verticalMoveChannel : "",


    }));

    linesData.map((item) => tempImages.push(item));
    linesData.map((item) => updatedImages.push(item));

    squareData = multipleSquare.slice(1).map((square, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: square.deviceName,
        deviceType: square.type,
        tabIndex: square.tabIndex,
        x: squarePosition.length > 0 ? squarePosition[index + 1]?.x : 0,
        y: squarePosition.length > 0 ? squarePosition[index + 1]?.y + 40 : 0,
        bgColor: square.bgColor ? square.bgColor : "#000000",
        width: updatedMultipleSquare[index + 1].width ? updatedMultipleSquare[index + 1].width : null,
        height: updatedMultipleSquare[index + 1].height ? updatedMultipleSquare[index + 1].height : null,
        onText: square.onText ? square.onText : "ON",
        offText: square.offText ? square.offText : "OFF",
        onColor: square.onColor ? square.onColor : "#00FF00",
        offColor: square.offColor ? square.offColor : "#FF0000",
        textColor: square.textColor ? square.textColor : "black",
        fontSize: square.fontSize ? square.fontSize : "14",
        text: square.text ? square.text : "",
        channelName: {
            PV: square.pvChannel ? square.pvChannel : "",
            SV: "",
        },
        hideChannel: square.hideChannel ? square.hideChannel : "",
        hideValue: square.hideValue ? square.hideValue : "",
        conditionValue: square.conditionValue ? square.conditionValue : {},
        moveValue: square.moveValue ? square.moveValue : {},
        horizontalMoveChannel: square.horizontalMoveChannel ? square.horizontalMoveChannel : "",
        verticalMoveChannel: square.verticalMoveChannel ? square.verticalMoveChannel : "",
        zIndex: square?.zIndex ? square?.zIndex : 1,
        blinkChannel: square.blinkChannel ? square.blinkChannel : "",
        blinkValue: square.blinkValue ? square.blinkValue : "",
        blinkFrequency: square.blinkFrequency ? square.blinkFrequency : 1,
        blinkFunction: square.blinkFunction ? square.blinkFunction : "=",
        borderRadius: square.borderRadius ? square.borderRadius : 0

    }));



    squareData.map((item) => tempImages.push(item));
    squareData.map((item) => updatedImages.push(item));


    circleData = multipleCircle.slice(1).map((circle, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: circle.deviceName,
        deviceType: circle.type,
        tabIndex: circle.tabIndex,
        x: circlePosition.length > 0 ? circlePosition[index + 1]?.x : 0,
        y: circlePosition.length > 0 ? circlePosition[index + 1]?.y + 40 : 0,
        bgColor: circle.bgColor ? circle.bgColor : "#ffffff",
        width: updatedMultipleCircle[index + 1].width ? updatedMultipleCircle[index + 1].width : null,
        height: updatedMultipleCircle[index + 1].height ? updatedMultipleCircle[index + 1].height : null,
        onText: circle.onText ? circle.onText : "ON",
        offText: circle.offText ? circle.offText : "OFF",
        onColor: circle.onColor ? circle.onColor : "#00FF00",
        offColor: circle.offColor ? circle.offColor : "#FF0000",
        textColor: circle.textColor ? circle.textColor : "black",
        fontSize: circle.fontSize ? circle.fontSize : "14",
        text: circle.text ? circle.text : "",
        channelName: {
            PV: circle.pvChannel ? circle.pvChannel : "",
            SV: "",
        },
        zIndex: circle?.zIndex ? circle?.zIndex : 1,
        hideChannel: circle.hideChannel ? circle.hideChannel : "",
        hideValue: circle.hideValue ? circle.hideValue : "",
        conditionValue: circle.conditionValue ? circle.conditionValue : {},
        moveValue: circle.moveValue ? circle.moveValue : {},
        horizontalMoveChannel: circle.horizontalMoveChannel ? circle.horizontalMoveChannel : "",
        verticalMoveChannel: circle.verticalMoveChannel ? circle.verticalMoveChannel : "",

    }));

    circleData.map((item) => tempImages.push(item));
    circleData.map((item) => updatedImages.push(item));



    polygoneData = multiplePolygone.slice(1).map((polygone, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: polygone.deviceName,
        deviceType: polygone.type,
        tabIndex: polygone.tabIndex,
        x: polygonePosition.length > 0 ? polygonePosition[index + 1]?.x : polygone.x,
        y: polygonePosition.length > 0 ? polygonePosition[index + 1]?.y : polygone.y,
        width: updatedMultiplePolygone[index + 1].width ? updatedMultiplePolygone[index + 1].width : null,
        height: updatedMultiplePolygone[index + 1].height ? updatedMultiplePolygone[index + 1].height : null,
        points: updatedMultiplePolygone[index + 1].points ? updatedMultiplePolygone[index + 1].points : [],
        bgColor: polygone.bgColor ? polygone.bgColor : "rgba(0, 0, 255, 0.3)",
        zIndex: polygone?.zIndex ? polygone?.zIndex : 1,
        hideChannel: polygone.hideChannel ? polygone.hideChannel : "",
        hideValue: polygone.hideValue ? polygone.hideValue : "",

    }));


    polygoneData.map((item) => tempImages.push(item));
    polygoneData.map((item) => updatedImages.push(item));


    pipeData = multiplePipe.slice(1).map((pipe, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: pipe.deviceName,
        deviceType: pipe.type,
        tabIndex: pipe.tabIndex,
        x: pipePosition.length > 0 ? pipePosition[index + 1]?.x : pipe.x,
        y: pipePosition.length > 0 ? pipePosition[index + 1]?.y : pipe.y,
        width: updatedMultiplePipe[index + 1].width ? updatedMultiplePipe[index + 1].width : null,
        height: updatedMultiplePipe[index + 1].height ? updatedMultiplePipe[index + 1].height : null,
        points: updatedMultiplePipe[index + 1].points ? updatedMultiplePipe[index + 1].points : [],
        bgColor: pipe.bgColor ?? pipe.bgColor,
        textColor: pipe.textColor ?? pipe.textColor,
        channelName: {
            PV: pipe.pvChannel ? pipe.pvChannel : "",
            SV: "",
        },
        zIndex: pipe?.zIndex ? pipe?.zIndex : 1,
        hideChannel: pipe.hideChannel ? pipe.hideChannel : "",
        hideValue: pipe.hideValue ? pipe.hideValue : "",

    }));


    pipeData.map((item) => tempImages.push(item));
    pipeData.map((item) => updatedImages.push(item));



    switchData = multipleSwitch.slice(1).map((i, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleSwitch[index + 1].deviceName,
        deviceType: multipleSwitch[index + 1].type,
        tabIndex: i.tabIndex,
        chartChannel: i.chartChannel ? i.chartChannel : [],
        x: switchPosition.length > 0 ? switchPosition[index + 1]?.x : 0,
        y: switchPosition.length > 0 ? switchPosition[index + 1]?.y + 40 : 0,
        on: 0,
        zIndex: i?.zIndex ? i?.zIndex : 1,
        hideChannel: i.hideChannel ? i.hideChannel : "",
        hideValue: i.hideValue ? i.hideValue : "",
        bgColor: i.bgColor ? i.bgColor : null,

    }));

    switchData.map((item) => tempImages.push(item));
    switchData.map((item) => updatedImages.push(item));

    checkboxData = multipleCheckbox.slice(1).map((i, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleCheckbox[index + 1].deviceName,
        deviceType: multipleCheckbox[index + 1].type,
        tabIndex: i.tabIndex,
        x: checkboxPosition.length > 0 ? checkboxPosition[index + 1]?.x : 0,
        y: checkboxPosition.length > 0 ? checkboxPosition[index + 1]?.y + 40 : 0,
        on: i?.on ? i.on : false,
        width: i?.width ? i?.width : "15px",
        height: i?.height ? i?.height : "15px",
        zIndex: i?.zIndex ? i?.zIndex : 1,
        hideChannel: i.hideChannel ? i.hideChannel : "",
        hideValue: i.hideValue ? i.hideValue : "",

    }));

    checkboxData.map((item) => tempImages.push(item));
    checkboxData.map((item) => updatedImages.push(item));


    radioData = multipleRadio.slice(1).map((Radio, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: Radio.deviceName,
        deviceType: Radio.type,
        tabIndex: Radio.tabIndex,
        x: radioPosition.length > 0 ? radioPosition[index + 1]?.x : 0,
        y: radioPosition.length > 0 ? radioPosition[index + 1]?.y + 40 : 0,
        width: updatedMultipleRadio[index + 1].width ? updatedMultipleRadio[index + 1].width : null,
        height: updatedMultipleRadio[index + 1].height ? updatedMultipleRadio[index + 1].height : null,
        points: Radio.points ? Radio.points : [],
        selectedIndex: Radio?.selectedIndex ? Radio.selectedIndex : 0,
        zIndex: Radio?.zIndex ? Radio?.zIndex : 1,
        hideChannel: Radio.hideChannel ? Radio.hideChannel : "",
        hideValue: Radio.hideValue ? Radio.hideValue : "",

    }));

    radioData.map((item) => tempImages.push(item));
    radioData.map((item) => updatedImages.push(item));


    sliderData = multipleSlider.slice(1).map((progressBar, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleSlider[index + 1].deviceName,
        deviceType: multipleSlider[index + 1].type,
        tabIndex: progressBar.tabIndex,
        x: sliderPosition.length > 0 ? sliderPosition[index + 1]?.x : 0,
        y: sliderPosition.length > 0 ? sliderPosition[index + 1]?.y + 40 : 0,
        chartChannel: progressBar.chartChannel ? progressBar.chartChannel : [],
        minVal: minimumVal.length > 0 ? minimumVal[index] : 0,
        maxVal: maximumVal.length > 0 ? maximumVal[index] : 100,
        width: updatedMultipleSlider[index + 1].width ? updatedMultipleSlider[index + 1].width : null,
        height: updatedMultipleSlider[index + 1].height ? updatedMultipleSlider[index + 1].height : null,
        zIndex: progressBar?.zIndex ? progressBar?.zIndex : 1,
        hideChannel: progressBar.hideChannel ? progressBar.hideChannel : "",
        hideValue: progressBar.hideValue ? progressBar.hideValue : "",
        bgColor: progressBar.bgColor ? progressBar.bgColor : null,
        textColor : progressBar.textColor ? progressBar.textColor : "black",
        fontSize: progressBar.fontSize ? progressBar.fontSize : null

    }));

    sliderData.map((item) => tempImages.push(item));
    sliderData.map((item) => updatedImages.push(item));


    lampData = multipleLamp.slice(1).map((Lamp, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: multipleLamp[index + 1].deviceName,
        deviceType: multipleLamp[index + 1].type,
        tabIndex: Lamp.tabIndex,
        x: lampPosition.length > 0 ? lampPosition[index + 1]?.x : 0,
        y: lampPosition.length > 0 ? lampPosition[index + 1]?.y + 40 : 0,
        chartChannel: Lamp.chartChannel ? Lamp.chartChannel : [],
        width: updatedMultipleLamp[index + 1].width ? updatedMultipleLamp[index + 1].width : null,
        height: updatedMultipleLamp[index + 1].height ? updatedMultipleLamp[index + 1].height : null,
        zIndex: Lamp?.zIndex ? Lamp?.zIndex : 1,
        lampStatus: Lamp?.lampStatus ?? [],
        hideChannel: Lamp.hideChannel ? Lamp.hideChannel : "",
        hideValue: Lamp.hideValue ? Lamp.hideValue : "",

    }));

    lampData.map((item) => tempImages.push(item));
    lampData.map((item) => updatedImages.push(item));


    pushData = multiplePush.slice(1).map((push, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: push.deviceName,
        deviceType: push.type,
        tabIndex: push.tabIndex,
        x: pushPosition.length > 0 ? pushPosition[index + 1]?.x : 0,
        y: pushPosition.length > 0 ? pushPosition[index + 1]?.y + 40 : 0,
        bgColor: push.bgColor ? push.bgColor : "#ffffff",
        width: updatedMultiplePush[index + 1].width ? updatedMultiplePush[index + 1].width : null,
        height: updatedMultiplePush[index + 1].height ? updatedMultiplePush[index + 1].height : null,
        zIndex: push?.zIndex ? push?.zIndex : 1,
        hideChannel: push.hideChannel ? push.hideChannel : "",
        hideValue: push.hideValue ? push.hideValue : "",


    }));

    pushData.map((item) => tempImages.push(item));
    pushData.map((item) => updatedImages.push(item));


    linkData = multipleLink.slice(1).map((Link, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: Link.deviceName,
        deviceType: Link.type,
        tabIndex: Link.tabIndex,
        text: Link.text ? Link.text : "Text",
        x: linkPosition.length > 0 ? linkPosition[index + 1]?.x : 0,
        y: linkPosition.length > 0 ? linkPosition[index + 1]?.y + 40 : 0,
        bgColor: Link.bgColor ? Link.bgColor : "#000000",
        textColor: Link.textColor ? Link.textColor : "#ffffff",
        fontSize: Link.fontSize ? Link.fontSize : "30",
        width: updatedMultipleLink[index + 1].width ? updatedMultipleLink[index + 1].width : null,
        height: updatedMultipleLink[index + 1].height ? updatedMultipleLink[index + 1].height : null,
        alignVertically: Link.alignVertically ? Link.alignVertically : textAlignVertically,
        alignHorizontally: Link.alignHorizontally ? Link.alignHorizontally : textAlignHorizontally,
        zIndex: Link?.zIndex ? Link?.zIndex : 1,
        hideChannel: Link.hideChannel ? Link.hideChannel : "",
        hideValue: Link.hideValue ? Link.hideValue : "",

    }))

    linkData.map((item) => tempImages.push(item));
    linkData.map((item) => updatedImages.push(item));


    clockData = multipleClock.slice(1).map((clock, index) => ({
        id: Math.floor(100000 + Math.random() * 900000),
        name: clock.deviceName,
        deviceType: clock.type,
        tabIndex: clock.tabIndex,
        x: clockPosition.length > 0 ? clockPosition[index + 1]?.x : 0,
        y: clockPosition.length > 0 ? clockPosition[index + 1]?.y + 40 : 0,
        fontSize: clock.fontSize ? clock.fontSize : "30",

        width: updatedMultipleClock[index + 1].width ? updatedMultipleClock[index + 1].width : null,
        height: updatedMultipleClock[index + 1].height ? updatedMultipleClock[index + 1].height : null,
        zIndex: clock?.zIndex ? clock?.zIndex : 1,
        hideChannel: clock.hideChannel ? clock.hideChannel : "",
        hideValue: clock.hideValue ? clock.hideValue : "",


    }));

    clockData.map((item) => tempImages.push(item));
    clockData.map((item) => updatedImages.push(item));



    setImages(tempImages);


    if (Object.keys(tabIndexOverviewInfo).length <= 0) {
        overviewInfoData = [
            {
                name: "overviewInfo",
                x: overviewInfoPosi ? overviewInfoPosi.x + 20 : null,
                y: overviewInfoPosi ? overviewInfoPosi.y : null,
                tabIndex: 0,
            },
        ];

        overviewInfoData.map((item) => tempImages.push(item));
        overviewInfoData.map((item) => updatedImages.push(item));

        setImages(tempImages);

    }

    if (Object.keys(tabIndexOverviewGraph).length <= 0) {
        overviewGraphData = [
            {
                name: "overviewGraph",
                x: overviewGraphPosi ? overviewGraphPosi.x + 750 : null,
                y: overviewGraphPosi ? overviewGraphPosi.y + 20 : null,
                tabIndex: 0,
                width: overviewGraphDimension ? overviewGraphDimension.width : null,
                height: overviewGraphDimension ? overviewGraphDimension.height : null,
            },
        ];

        overviewGraphData.map((item) => tempImages.push(item));
        overviewGraphData.map((item) => updatedImages.push(item));

        setImages(tempImages);
    }

    if (Object.keys(tabIndexLiveDataGraph).length <= 0) {
        liveGraphData = [
            {
                name: "liveDataGraph",
                x: liveDataGraphPosi ? liveDataGraphPosi.x + 300 : null,
                y: liveDataGraphPosi ? liveDataGraphPosi.y + 150 : null,
                tabIndex: 2,
                width: liveDataGraphDimension ? liveDataGraphDimension.width : null,
                height: liveDataGraphDimension ? liveDataGraphDimension.height : null,
            },
        ];

        liveGraphData.map((item) => tempImages.push(item));
        liveGraphData.map((item) => updatedImages.push(item));

        setImages(tempImages);
    }

    if (Object.keys(tabIndexLastDayTable).length <= 0) {
        lastDayTableData = [
            {
                name: "lastDayTable",
                x: lastDayTablePosi ? lastDayTablePosi.x + 10 : null,
                y: lastDayTablePosi ? lastDayTablePosi.y + 200 : null,
                tabIndex: 3,
                width: lastDayTableDimension ? lastDayTableDimension.width : null,
                height: lastDayTableDimension ? lastDayTableDimension.height : null,
            },
        ];

        lastDayTableData.map((item) => tempImages.push(item));
        lastDayTableData.map((item) => updatedImages.push(item));

        setImages(tempImages);
    }

    if (Object.keys(tabIndexLastDayGraph).length <= 0) {
        lastDayGraphData = [
            {
                name: "lastDayGraph",
                x: lastDayGraphPosi ? lastDayGraphPosi.x + 500 : null,
                y: lastDayGraphPosi ? lastDayGraphPosi.y : null,
                tabIndex: 3,
                width: lastDayGraphDimension ? lastDayGraphDimension.width : null,
                height: lastDayGraphDimension ? lastDayGraphDimension.height : null,
            },
        ];

        lastDayGraphData.map((item) => tempImages.push(item));
        lastDayGraphData.map((item) => updatedImages.push(item));

        setImages(tempImages);
    }

    if (Object.keys(tabIndexDefaultGrid).length <= 0) {
        defaultGridData = [
            {
                name: "DefaultGrid",
                x: defaultGridPosi ? defaultGridPosi.x : null,
                y: defaultGridPosi ? defaultGridPosi.y + 70 : null,
                tabIndex: 1,
                width: defaultGridDimension ? defaultGridDimension.width : null,
                height: defaultGridDimension ? defaultGridDimension.height : null,
            },
        ];

        defaultGridData.map((item) => tempImages.push(item));
        defaultGridData.map((item) => updatedImages.push(item));

        setImages(tempImages);
    }

    // removing the element with index of -1
    let removeIndex = tempImages[-1];

    if (removeIndex) {
        tempImages.splice(-1, 1);
    }
    console.log("save:" , containerDimensions)
    const filteredTempImages = await removeDuplicates(tempImages);
    await dispatch(
        addWidget({
            filteredTempImages,
            tempTabNames,
            windowHeight,
            windowWidth,
            uniqueProjectId,
            containerDimensions
        })
    ).then(async (response) => {
        if (response.payload.responseBody.status === 200) {

            toast({
                title: response.payload.responseBody.message,
                status: "success",
                position: "top-right",
                duration: 3000,
                isClosable: true,
            });

            const newWidgets = response.payload.responseBody.widgetId[0]?.widget;

            let widgetWithID = [];
            newWidgets.forEach((widget, index) => {
                const currentTempWidget = updatedImages[index];

                const currentWidget = {
                    ...currentTempWidget,
                    id: widget.id,
                }

                widgetWithID.push(currentWidget)
            })

            setUpdatedImages(widgetWithID);
            // setTempImages(widgetWithID);

            if (deviceData.length > 0) {

                deviceData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, channelName, deviceType, unit, zIndex } =
                        device;
                    setTempTabIndexDevices(prevState => {
                        const allDeviceData = { ...prevState }; // Copy previous state

                        if (deviceType === "Indicator") {
                            if (!allDeviceData[tabIndex]) {
                                allDeviceData[tabIndex] = [];
                            }
                            allDeviceData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                channelName,
                                unit,
                                zIndex
                            });
                        }

                        return allDeviceData; // Update state with the new data
                    });

                })
            }


            const newArrayDevice = multipleDevices.slice(0, 1);
            setMultipleDevices(newArrayDevice);

            if (displayData.length > 0) {

                displayData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, channelName, deviceType, width, height, bgColor, textColor, fontSize, zIndex, hideChannel, hideValue } =
                        device;
                    setTempTabIndexDisplay(prevState => {
                        const allDeviceData = { ...prevState }; // Copy previous state

                        if (deviceType === "Display") {
                            if (!allDeviceData[tabIndex]) {
                                allDeviceData[tabIndex] = [];
                            }
                            allDeviceData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                channelName,
                                width,
                                height,
                                bgColor,
                                textColor,
                                fontSize,
                                zIndex,
                                hideChannel, hideValue
                            });
                        }

                        return allDeviceData; // Update state with the new data
                    });
                })
            }

            const newArrayDisplay = multipleDisplay.slice(0, 1);
            setMultipleDisplay(newArrayDisplay);

            // adding new controller with previous controller
            // const allControllerData = {};
            if (controllerData.length > 0) {

                controllerData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, channelName, deviceType, unit, zIndex } = device;

                    setTempTabIndexController(prevState => {
                        const allControllerData = { ...prevState }; // Copy previous state
                        if (deviceType === "Controller") {
                            if (!allControllerData[tabIndex]) {
                                allControllerData[tabIndex] = [];
                            }
                            allControllerData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                channelName,
                                unit,
                                zIndex
                            });
                        }

                        return allControllerData; // Update state with the new data
                    });

                });
            }

            const newArrayController = multipleController.slice(0, 1);
            setMultipleController(newArrayController);

            // adding new digital IO with previous Digital IO

            if (ioData.length > 0) {

                ioData?.forEach((device, index) => {

                    const { name, x, y, id, tabIndex, channelName, deviceType, on, onText, offText, onColor, offColor, fontSize, zIndex, hideChannel, hideValue, conditionValue, moveValue, horizontalMoveChannel, verticalMoveChannel, } = device;

                    setTempTabIndexIO(prevState => {
                        const allIOData = { ...prevState }; // Copy previous state

                        if (deviceType === "DigitalIO") {
                            if (!allIOData[tabIndex]) {
                                allIOData[tabIndex] = [];
                            }
                            allIOData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                channelName,
                                on,
                                onText,
                                offText,
                                onColor,
                                offColor,
                                fontSize,
                                zIndex,
                                hideChannel, hideValue, conditionValue, moveValue, horizontalMoveChannel, verticalMoveChannel,
                            });
                        }

                        return allIOData; // Update state with the new data
                    });

                });
            }

            const newArrayIo = multipleIO.slice(0, 1);
            setMultipleIO(newArrayIo);

            // adding new Flow meter with previous Flow meter

            if (flowMeterData.length > 0) {

                flowMeterData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, channelName, deviceType, unitPv, unitSv, zIndex } =
                        device;

                    setTempTabIndexFlowM(prevState => {
                        const allFlowMData = { ...prevState }; // Copy previous state

                        if (deviceType === "FlowMeter") {
                            if (!allFlowMData[tabIndex]) {
                                allFlowMData[tabIndex] = [];
                            }
                            allFlowMData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                channelName,
                                unitPv,
                                unitSv,
                                zIndex
                            });
                        }


                        return allFlowMData; // Update state with the new data
                    });

                });
            }

            const newArrayFlow = multipleFlowM.slice(0, 1);
            setMultipleFlowM(newArrayFlow);

            // adding new Energy meter with previous Energy Meter

            if (energyMeterData.length > 0) {

                energyMeterData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, channelName, deviceType, unitPv, unitSv, unitSv2, unitSv3, zIndex } =
                        device;

                    setTempTabIndexEnergyM(prevState => {
                        const allEnergyMData = { ...prevState }; // Copy previous state

                        if (deviceType === "EnergyMeter") {
                            if (!allEnergyMData[tabIndex]) {
                                allEnergyMData[tabIndex] = [];
                            }
                            allEnergyMData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                channelName,
                                unitPv,
                                unitSv,
                                unitSv2,
                                unitSv3,
                                zIndex
                            });
                        }

                        return allEnergyMData; // Update state with the new data
                    });

                });
            }

            const newArrayEnergyM = multipleEnergyM.slice(0, 1);
            setMultipleEnergyM(newArrayEnergyM);




            if (motorData.length > 0) {

                motorData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, deviceType, width, height, on, channelName, zIndex, hideChannel, hideValue } =
                        device;

                    setTempTabIndexMotor(prevState => {
                        const allMotorData = { ...prevState }; // Copy previous state

                        if (deviceType === "Motor") {
                            if (!allMotorData[tabIndex]) {
                                allMotorData[tabIndex] = [];
                            }
                            allMotorData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                width,
                                height,
                                on,
                                channelName,
                                zIndex,
                                hideChannel,
                                hideValue
                            });
                        }

                        return allMotorData; // Update state with the new data
                    });

                });
            }

            const newArrayMotor = multipleMotor.slice(0, 1);
            setMultipleMotor(newArrayMotor);

            // For Text

            if (textData.length > 0) {

                textData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, text, channelName, deviceType, width, height, bgColor, textColor, fontSize, alignHorizontally, alignVertically, zIndex, hideChannel, hideValue, isTransparent } =
                        device;
                    setTempTabIndexText(prevState => {
                        const allDeviceData = { ...prevState }; // Copy previous state

                        if (deviceType === "Text") {
                            if (!allDeviceData[tabIndex]) {
                                allDeviceData[tabIndex] = [];
                            }
                            allDeviceData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                channelName,
                                width,
                                height,
                                bgColor,
                                textColor,
                                fontSize,
                                text,
                                alignHorizontally,
                                alignVertically,
                                zIndex,
                                isTransparent,
                                hideChannel, hideValue
                            });
                        }

                        return allDeviceData; // Update state with the new data
                    });
                })
            }

            const newArrayText = multipleText.slice(0, 1);
            setMultipleText(newArrayText);

            // adding new line charts with previous line charts

            if (lineChartData.length > 0) {

                lineChartData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        chartChannel,
                        deviceType,
                        width,
                        height,
                        hour,
                        minute,
                        zIndex,
                        lineStyle,
                        isCurveLine,
                        isSteppedLine,
                        minY,
                        maxY,
                        xInterval,
                        yInterval
                    } = device;

                    setTempTabIndexLineChart(prevState => {
                        const allLineChartsData = { ...prevState }; // Copy previous state

                        if (deviceType === "LineChart") {
                            if (!allLineChartsData[tabIndex]) {
                                allLineChartsData[tabIndex] = [];
                            }
                            allLineChartsData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                chartChannel,
                                deviceType,
                                width,
                                height,
                                hour,
                                minute,
                                zIndex,
                                lineStyle,
                                isCurveLine,
                                isSteppedLine,
                                minY,
                                maxY,
                                xInterval,
                                yInterval
                            });
                        }

                        return allLineChartsData; // Update state with the new data
                    });

                });
            }

            const newArrayLineChart = multipleLineCharts.slice(0, 1);
            setMultipleLineCharts(newArrayLineChart);


            // adding new pie charts with previous pie charts 

            if (pieChartData.length > 0) {

                pieChartData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        chartChannel,
                        deviceType,
                        width,
                        height,
                        zIndex
                    } = device;

                    setTempTabIndexPieChart(prevState => {
                        const allPieChartData = { ...prevState }; // Copy previous state

                        if (deviceType === "PieChart") {
                            if (!allPieChartData[tabIndex]) {
                                allPieChartData[tabIndex] = [];
                            }

                            allPieChartData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                chartChannel,
                                deviceType,
                                width,
                                height,
                                zIndex
                            });
                        }

                        return allPieChartData; // Update state with the new data
                    });

                });
            }

            const newArrayPieChart = multiplePieChart.slice(0, 1);
            setMultiplePieChart(newArrayPieChart);

            // adding new bar charts with previous bar charts

            if (toolbarChartData.length > 0) {

                toolbarChartData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        chartChannel,
                        deviceType,
                        width,
                        height,
                        zIndex

                    } = device;

                    setTempTabIndexBarChart(prevState => {
                        const allBarChartData = { ...prevState }; // Copy previous state

                        if (deviceType === "BarChart") {
                            if (!allBarChartData[tabIndex]) {
                                allBarChartData[tabIndex] = [];
                            }
                            allBarChartData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                chartChannel,
                                deviceType,
                                width,
                                height,
                                zIndex
                            });
                        }

                        return allBarChartData; // Update state with the new data
                    });

                });
            }


            const newArrayBarChart = multipleBarChart.slice(0, 1);
            setMultipleBarChart(newArrayBarChart);


            // adding new histogram with previous histogram

            if (toolBarhistogramData.length > 0) {

                toolBarhistogramData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        chartChannel,
                        deviceType,
                        width,
                        height,
                        hour,
                        minute,
                        zIndex
                    } = device;

                    setTempTabIndexHistogram(prevState => {
                        const allHistogramData = { ...prevState }; // Copy previous state

                        if (deviceType === "Histogram") {
                            if (!allHistogramData[tabIndex]) {
                                allHistogramData[tabIndex] = [];
                            }
                            allHistogramData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                chartChannel,
                                deviceType,
                                width,
                                height,
                                hour,
                                minute,
                                zIndex
                            });
                        }

                        return allHistogramData; // Update state with the new data
                    });

                });
            }

            const newArrayHistogram = multipleHistogram.slice(0, 1);
            setMultipleHistogram(newArrayHistogram);

            // adding new gauge with previous gauge

            if (gaugeData.length > 0) {

                gaugeData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        chartChannel,
                        deviceType,
                        maxVal,
                        minVal,
                        width,
                        height,
                        fontSize,
                        zIndex
                    } = device;

                    setTempTabIndexGauge(prevState => {
                        const allGaugeData = { ...prevState }; // Copy previous state

                        if (deviceType === "Gauge") {
                            if (!allGaugeData[tabIndex]) {
                                allGaugeData[tabIndex] = [];
                            }
                            allGaugeData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                chartChannel,
                                deviceType,
                                maxVal,
                                minVal,
                                width,
                                height,
                                fontSize,
                                zIndex
                            });
                        }

                        return allGaugeData; // Update state with the new data
                    });

                });
            }

            const newArrayGauge = multipleGauge.slice(0, 1);
            setMultipleGauge(newArrayGauge);


            // adding new progress bar with previous progress bar

            if (progressBarData.length > 0) {

                progressBarData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        chartChannel,
                        deviceType,
                        maxVal,
                        minVal,
                        rotate,
                        width,
                        height,
                        fontSize,
                        bgColor,
                        zIndex
                    } = device;

                    setTempTabIndexProgress(prevState => {
                        const allProgressBarData = { ...prevState }; // Copy previous state

                        if (deviceType === "ProgressBar") {
                            if (!allProgressBarData[tabIndex]) {
                                allProgressBarData[tabIndex] = [];
                            }
                            allProgressBarData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                chartChannel,
                                deviceType,
                                maxVal,
                                minVal,
                                rotate,
                                width,
                                height,
                                fontSize,
                                bgColor,
                                zIndex
                            });
                        }


                        return allProgressBarData; // Update state with the new data
                    });

                });
            }


            const newArrayProgress = multipleProgress.slice(0, 1);
            setMultipleProgress(newArrayProgress);


            if (gridData.length > 0) {

                gridData?.forEach((device, index) => {

                    const { id,
                        name,
                        x,
                        y,
                        tabIndex,
                        chartChannel,
                        deviceType,
                        width,
                        height,
                        zIndex
                    } = device;

                    setTempTabIndexGrid(prevState => {
                        const allGridData = { ...prevState }; // Copy previous state

                        if (deviceType === "Grid") {
                            if (!allGridData[tabIndex]) {
                                allGridData[tabIndex] = [];
                            }
                            allGridData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                chartChannel,
                                deviceType,
                                width,
                                height,
                                zIndex
                            });
                        }

                        return allGridData; // Update state with the new data
                    });

                });
            }


            const newArrayGrid = multipleGrid.slice(0, 1);
            setMultipleGrid(newArrayGrid);


            if (toolBarTableData.length > 0) {

                toolBarTableData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        chartChannel,
                        deviceType,
                        width,
                        height,
                        column,
                        zIndex
                    } = device;

                    setTempTabIndexTable(prevState => {
                        const allTableData = { ...prevState }; // Copy previous state

                        if (deviceType === "Table") {
                            if (!allTableData[tabIndex]) {
                                allTableData[tabIndex] = [];
                            }
                            allTableData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                chartChannel,
                                deviceType,
                                width,
                                height,
                                column,
                                zIndex
                            });
                        }


                        return allTableData; // Update state with the new data
                    });

                });
            }

            const newArrayTable = multipleTable.slice(0, 1);
            setMultipleTable(newArrayTable);

            // adding new progress bar with previous progress bar

            if (circularProgressData.length > 0) {

                circularProgressData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        deviceType,
                        width,
                        height,
                        chartChannel,
                        maxVal,
                        zIndex
                    } = device;

                    setTempTabIndexCircularProgress(prevState => {
                        const allProgressBarData = { ...prevState }; // Copy previous state

                        if (deviceType === "CircularProgress") {
                            if (!allProgressBarData[tabIndex]) {
                                allProgressBarData[tabIndex] = [];
                            }
                            allProgressBarData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                deviceType,
                                width,
                                height,
                                chartChannel,
                                maxVal,
                                zIndex
                            });
                        }


                        return allProgressBarData; // Update state with the new data
                    });

                });
            }


            const newCircularProgress = multipleCircularProgress.slice(0, 1);
            setMultipleCircularProgress(newCircularProgress);

            // adding new pie charts with previous pie charts 

            if (doughnutData.length > 0) {

                doughnutData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        chartChannel,
                        deviceType,
                        width,
                        height,
                        zIndex
                    } = device;

                    setTempTabIndexDoughnut(prevState => {
                        const allDoughnutData = { ...prevState }; // Copy previous state

                        if (deviceType === "Doughnut") {
                            if (!allDoughnutData[tabIndex]) {
                                allDoughnutData[tabIndex] = [];
                            }

                            allDoughnutData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                chartChannel,
                                deviceType,
                                width,
                                height,
                                zIndex
                            });
                        }

                        return allDoughnutData; // Update state with the new data
                    });

                });
            }

            const newArrayDoughnut = multipleDoughnut.slice(0, 1);
            setMultipleDoughnut(newArrayDoughnut);

            if (linesData.length > 0) {

                linesData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        deviceType,
                        width,
                        height,
                        length,
                        deltaX,
                        deltaY,

                        angle,
                        zIndex,
                        hideValue,
                        hideChannel,
                        bgColor,
                        moveValue,
                        conditionValue,
                        horizontalMoveChannel,
                        verticalMoveChannel
                    } = device;

                    setTempTabIndexLines(prevState => {
                        const allLinesData = { ...prevState }; // Copy previous state

                        if (deviceType === "Line") {
                            if (!allLinesData[tabIndex]) {
                                allLinesData[tabIndex] = [];
                            }
                            allLinesData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                deviceType,
                                width,
                                height,
                                length,
                                deltaX,
                                deltaY,
                                angle,
                                zIndex,
                                hideValue,
                                hideChannel,
                                bgColor,
                                moveValue,
                                conditionValue,
                                horizontalMoveChannel,
                                verticalMoveChannel
                            });
                        }


                        return allLinesData; // Update state with the new data
                    });

                });
            }

            const newArrayLines = multipleLines.slice(0, 1);
            setMultipleLines(newArrayLines);

            if (squareData.length > 0) {

                squareData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, deviceType, width, height, bgColor, onText, offText, onColor, offColor, text, fontSize, channelName, textColor, hideChannel, conditionValue, moveValue, hideValue, horizontalMoveChannel, verticalMoveChannel, zIndex } =
                        device;
                    setTempTabIndexSquare(prevState => {
                        const allDeviceData = { ...prevState }; // Copy previous state

                        if (deviceType === "Square") {
                            if (!allDeviceData[tabIndex]) {
                                allDeviceData[tabIndex] = [];
                            }
                            allDeviceData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                width,
                                height,
                                bgColor,
                                onText,
                                offText,
                                onColor,
                                offColor,
                                text,
                                fontSize,
                                channelName,
                                textColor,
                                hideChannel,
                                hideValue,
                                conditionValue,
                                moveValue,
                                horizontalMoveChannel,
                                verticalMoveChannel,
                                zIndex,

                            });
                        }

                        return allDeviceData; // Update state with the new data
                    });
                })
            }

            const newArraySquare = multipleSquare.slice(0, 1);
            setMultipleSquare(newArraySquare);


            if (circleData.length > 0) {

                circleData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, deviceType, width, height, bgColor, onText,
                        offText,
                        onColor,
                        offColor,
                        text,
                        fontSize,
                        channelName,
                        textColor,
                        zIndex,
                        hideChannel,
                        hideValue,
                        conditionValue,
                        moveValue,
                        horizontalMoveChannel,
                        verticalMoveChannel,
                    } =

                        device;
                    setTempTabIndexCircle(prevState => {
                        const allDeviceData = { ...prevState }; // Copy previous state

                        if (deviceType === "Circle") {
                            if (!allDeviceData[tabIndex]) {
                                allDeviceData[tabIndex] = [];
                            }
                            allDeviceData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                width,
                                height,
                                bgColor,
                                onText,
                                offText,
                                onColor,
                                offColor,
                                text,
                                fontSize,
                                channelName,
                                textColor,
                                hideChannel,
                                hideValue,
                                conditionValue,
                                moveValue,
                                horizontalMoveChannel,
                                verticalMoveChannel,
                                zIndex,
                            });
                        }

                        return allDeviceData; // Update state with the new data
                    });
                })
            }

            const newArrayCircle = multipleCircle.slice(0, 1);
            setMultipleCircle(newArrayCircle);


            if (polygoneData.length > 0) {

                polygoneData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, deviceType, width, height, bgColor, points, zIndex, hideChannel, hideValue } =
                        device;
                    setTempTabIndexPolygone(prevState => {
                        const allDeviceData = { ...prevState }; // Copy previous state

                        if (deviceType === "Polygone") {
                            if (!allDeviceData[tabIndex]) {
                                allDeviceData[tabIndex] = [];
                            }
                            allDeviceData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                width,
                                height,
                                bgColor,
                                points,
                                zIndex,
                                hideChannel, hideValue
                            });
                        }

                        return allDeviceData; // Update state with the new data
                    });
                })
            }

            const newArrayPolygone = multiplePolygone.slice(0, 1);
            setMultiplePolygone(newArrayPolygone);

            if (pipeData.length > 0) {

                pipeData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, deviceType, width, height, bgColor, textColor, points, channelName, zIndex, hideChannel, hideValue } =
                        device;
                    setTempTabIndexPipe(prevState => {
                        const allDeviceData = { ...prevState }; // Copy previous state

                        if (deviceType === "Pipe") {
                            if (!allDeviceData[tabIndex]) {
                                allDeviceData[tabIndex] = [];
                            }
                            allDeviceData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                width,
                                height,
                                bgColor,
                                textColor,
                                points,
                                channelName,
                                zIndex,
                                hideChannel, hideValue
                            });
                        }

                        return allDeviceData; // Update state with the new data
                    });
                })
            }

            const newArrayPipe = multiplePipe.slice(0, 1);
            setMultiplePipe(newArrayPipe);

            if (switchData.length > 0) {

                switchData?.forEach((device, index) => {

                    const { name, x, y, id, tabIndex, channelName, deviceType, on, zIndex, hideChannel, hideValue, bgColor } = device;

                    setTempTabIndexSwitch(prevState => {
                        const allIOData = { ...prevState }; // Copy previous state

                        if (deviceType === "Switch") {
                            if (!allIOData[tabIndex]) {
                                allIOData[tabIndex] = [];
                            }
                            allIOData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                channelName,
                                on,
                                zIndex,
                                bgColor,
                                hideChannel, hideValue
                            });
                        }

                        return allIOData; // Update state with the new data
                    });

                });
            }

            const newArraySwitch = multipleSwitch.slice(0, 1);
            setMultipleSwitch(newArraySwitch);

            if (checkboxData.length > 0) {

                checkboxData?.forEach((device, index) => {

                    const { name, x, y, id, tabIndex, channelName, deviceType, width, height, on, zIndex, hideChannel, hideValue } = device;

                    setTempTabIndexCheckbox(prevState => {
                        const allCheckboxData = { ...prevState }; // Copy previous state

                        if (deviceType === "Checkbox") {
                            if (!allCheckboxData[tabIndex]) {
                                allCheckboxData[tabIndex] = [];
                            }
                            allCheckboxData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                channelName,
                                width,
                                height, on,
                                zIndex,
                                hideChannel, hideValue

                            });
                        }

                        return allCheckboxData; // Update state with the new data
                    });

                });
            }

            const newArrayCheckbox = multipleCheckbox.slice(0, 1);
            setMultipleCheckbox(newArrayCheckbox);


            if (radioData.length > 0) {

                radioData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, deviceType, width, height, points, selectedIndex, zIndex, hideChannel, hideValue } =
                        device;
                    setTempTabIndexRadio(prevState => {
                        const allDeviceData = { ...prevState }; // Copy previous state

                        if (deviceType === "Radio") {
                            if (!allDeviceData[tabIndex]) {
                                allDeviceData[tabIndex] = [];
                            }
                            allDeviceData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                width,
                                height,
                                points,
                                selectedIndex,
                                zIndex,
                                hideChannel, hideValue
                            });
                        }

                        return allDeviceData; // Update state with the new data
                    });
                })
            }

            const newArrayRadio = multipleRadio.slice(0, 1);
            setMultipleRadio(newArrayRadio);



            if (sliderData.length > 0) {

                sliderData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        chartChannel,
                        deviceType,
                        maxVal,
                        minVal,
                        width,
                        height,
                        zIndex,
                        bgColor,
                        fontSize,
                        textColor,
                        hideChannel, hideValue
                    } = device;

                    setTempTabIndexSlider(prevState => {
                        const allSliderData = { ...prevState }; // Copy previous state

                        if (deviceType === "Slider") {
                            if (!allSliderData[tabIndex]) {
                                allSliderData[tabIndex] = [];
                            }
                            allSliderData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                chartChannel,
                                deviceType,
                                maxVal,
                                minVal,
                                width,
                                height,
                                zIndex,
                                bgColor,
                                fontSize,
                                textColor,
                                hideChannel, hideValue
                            });
                        }


                        return allSliderData; // Update state with the new data
                    });

                });
            }


            const newArraySlider = multipleSlider.slice(0, 1);
            setMultipleSlider(newArraySlider);

            if (lampData.length > 0) {

                lampData?.forEach((device, index) => {

                    const {
                        id,
                        name,
                        x,
                        y,
                        tabIndex,
                        chartChannel,
                        deviceType,
                        width,
                        height,
                        zIndex,
                        hideChannel, hideValue
                    } = device;

                    setTempTabIndexLamp(prevState => {
                        const allLampData = { ...prevState }; // Copy previous state

                        if (deviceType === "Lamp") {
                            if (!allLampData[tabIndex]) {
                                allLampData[tabIndex] = [];
                            }
                            allLampData[tabIndex].push({
                                id,
                                name,
                                x,
                                y,
                                tabIndex,
                                chartChannel,
                                deviceType,
                                width,
                                height,
                                zIndex,
                                hideChannel, hideValue
                            });
                        }


                        return allLampData; // Update state with the new data
                    });

                });
            }


            const newArrayLamp = multipleLamp.slice(0, 1);
            setMultipleLamp(newArrayLamp);


            if (pushData.length > 0) {

                pushData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, deviceType, width, height, bgColor, zIndex, hideChannel, hideValue } =
                        device;
                    setTempTabIndexPush(prevState => {
                        const allDeviceData = { ...prevState }; // Copy previous state

                        if (deviceType === "Push") {
                            if (!allDeviceData[tabIndex]) {
                                allDeviceData[tabIndex] = [];
                            }
                            allDeviceData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                width,
                                height,
                                bgColor,
                                zIndex,
                                hideChannel, hideValue
                            });
                        }

                        return allDeviceData; // Update state with the new data
                    });
                })
            }

            const newArrayPush = multiplePush.slice(0, 1);
            setMultiplePush(newArrayPush);


            // For Link

            if (linkData.length > 0) {

                linkData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, text, channelName, deviceType, width, height, bgColor, textColor, fontSize, alignHorizontally, alignVertically, zIndex, hideChannel, hideValue } =
                        device;
                    setTempTabIndexLink(prevState => {
                        const allDeviceData = { ...prevState }; // Copy previous state

                        if (deviceType === "Link") {
                            if (!allDeviceData[tabIndex]) {
                                allDeviceData[tabIndex] = [];
                            }
                            allDeviceData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                channelName,
                                width,
                                height,
                                bgColor,
                                textColor,
                                fontSize,
                                text,
                                alignHorizontally,
                                alignVertically,
                                zIndex,
                                hideChannel, hideValue
                            });
                        }

                        return allDeviceData; // Update state with the new data
                    });
                })
            }

            const newArrayLink = multipleLink.slice(0, 1);
            setMultipleLink(newArrayLink);


            if (clockData.length > 0) {

                clockData?.forEach((device, index) => {

                    const { name, x, y, tabIndex, id, deviceType, width, height, fontSize, zIndex, hideChannel, hideValue } =
                        device;
                    setTempTabIndexClock(prevState => {
                        const allDeviceData = { ...prevState }; // Copy previous state

                        if (deviceType === "Clock") {
                            if (!allDeviceData[tabIndex]) {
                                allDeviceData[tabIndex] = [];
                            }
                            allDeviceData[tabIndex].push({
                                id,
                                x,
                                y,
                                deviceType,
                                name,
                                tabIndex,
                                width,
                                height,
                                fontSize,
                                zIndex, hideChannel, hideValue
                            });
                        }

                        return allDeviceData; // Update state with the new data
                    });
                })
            }

            const newArrayClock = multipleClock.slice(0, 1);
            setMultipleClock(newArrayClock);


            // updating position of images
            const newPositionDataImages = {};

            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    tabIndex,
                    id,
                    hideChannel,
                    hideValue,
                    conditionValue,
                    moveValue,
                    horizontalMoveChannel,
                    verticalMoveChannel,
                    zIndex
                } = data;

                if (name && name.toLowerCase().includes("image")) {

                    if (!newPositionDataImages[tabIndex]) {
                        newPositionDataImages[tabIndex] = [];
                    }

                    newPositionDataImages[tabIndex].push({
                        x,
                        y,
                        name,
                        height,
                        tabIndex,
                        id,
                        width,
                        zIndex,
                        hideChannel,
                        hideValue,
                        conditionValue,
                        moveValue,
                        horizontalMoveChannel,
                        verticalMoveChannel,
                    });
                }
            });


            setTabIndexImages(newPositionDataImages);


            // updating position of indicator
            const newPositionDataIndicator = {};

            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    name,
                    tabIndex,
                    id,
                    channelName,
                    deviceType,
                    unit,
                    zIndex
                } = data;
                if (deviceType === "Indicator") {
                    if (!newPositionDataIndicator[tabIndex]) {
                        newPositionDataIndicator[tabIndex] = [];
                    }
                    newPositionDataIndicator[tabIndex].push({
                        x,
                        y,
                        name,
                        channelName,
                        tabIndex,
                        id,
                        deviceType,
                        unit,
                        zIndex
                    });
                }
            });

            setTabIndexDevices(newPositionDataIndicator);
            setUpdatedTabIndexDevices(newPositionDataIndicator);

            const newPositionDataDisplay = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    tabIndex,
                    id,
                    channelName,
                    deviceType,
                    bgColor,
                    textColor,
                    fontSize,
                    hideChannel, hideValue,
                    zIndex
                } = data;
                if (deviceType === "Display") {
                    if (!newPositionDataDisplay[tabIndex]) {
                        newPositionDataDisplay[tabIndex] = [];
                    }
                    newPositionDataDisplay[tabIndex].push({
                        x,
                        y,
                        name,
                        channelName,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        bgColor,
                        textColor,
                        fontSize,
                        zIndex,
                        hideChannel, hideValue
                    });
                }
            });

            setTabIndexDisplay(newPositionDataDisplay);
            setUpdatedTabIndexDisplay(newPositionDataDisplay);

            //updating position of Controller
            const newPositionDataController = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    name,
                    tabIndex,
                    id,
                    channelName,
                    deviceType,
                    unit,
                    zIndex
                } = data;
                if (deviceType === "Controller") {
                    if (!newPositionDataController[tabIndex]) {
                        newPositionDataController[tabIndex] = [];
                    }
                    newPositionDataController[tabIndex].push({
                        x,
                        y,
                        name,
                        channelName,
                        tabIndex,
                        id,
                        deviceType,
                        unit,
                        zIndex
                    });
                }
            });

            setTabIndexController(newPositionDataController);
            setUpdatedTabIndexController(newPositionDataController);

            //updating position of Digital I/O
            const newPositionDataIO = {};
            tempImages.forEach((data, index) => {
                const { x, y, name, tabIndex, id, on, deviceType, onText, offText, onColor, offColor, channelName, fontSize, zIndex, hideChannel, hideValue, conditionValue, moveValue, horizontalMoveChannel, verticalMoveChannel, } = data;
                if (deviceType === "DigitalIO") {
                    if (!newPositionDataIO[tabIndex]) {
                        newPositionDataIO[tabIndex] = [];
                    }
                    newPositionDataIO[tabIndex].push({

                        x,
                        y,
                        name,
                        on,
                        tabIndex,
                        id,
                        deviceType,
                        onText,
                        offText,
                        onColor,
                        offColor,
                        channelName,
                        fontSize,
                        zIndex,
                        hideChannel, hideValue, conditionValue, moveValue, horizontalMoveChannel, verticalMoveChannel,
                    });
                }
            });

            setTabIndexIO(newPositionDataIO);
            setUpdatedTabIndexIO(newPositionDataIO);

            //updating position of flow meter
            const newPositionDataFlowM = {};
            tempImages.forEach((data, index) => {
                const {
                    id,
                    x,
                    y,
                    name,
                    tabIndex,
                    channelName,
                    deviceType,
                    unit,
                    zIndex
                } = data;
                if (deviceType === "FlowMeter") {
                    if (!newPositionDataFlowM[tabIndex]) {
                        newPositionDataFlowM[tabIndex] = [];
                    }
                    newPositionDataFlowM[tabIndex].push({

                        x,
                        y,
                        name,
                        channelName,
                        tabIndex,
                        id,
                        deviceType,
                        unit,
                        zIndex
                    });
                }
            });
            setTabIndexFlowM(newPositionDataFlowM);
            setUpdatedTabIndexFlowM(newPositionDataFlowM);

            //updating position of energy meter
            const newPositionDataEnergyM = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    name,
                    tabIndex,
                    id,
                    channelName,
                    deviceType,
                    unit,
                    zIndex
                } = data;
                if (deviceType === "EnergyMeter") {
                    if (!newPositionDataEnergyM[tabIndex]) {
                        newPositionDataEnergyM[tabIndex] = [];
                    }
                    newPositionDataEnergyM[tabIndex].push({
                        x,
                        y,
                        name,
                        channelName,
                        tabIndex,
                        id,
                        deviceType,
                        unit,
                        zIndex
                    });
                }
            });
            setTabIndexEnergyM(newPositionDataEnergyM);
            setUpdatedTabIndexEnergyM(newPositionDataEnergyM);


            const newPositionDataMotor = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    tabIndex,
                    id,
                    deviceType,
                    on,
                    channelName,
                    zIndex,
                    hideChannel, hideValue
                } = data;
                if (deviceType === "Motor") {
                    if (!newPositionDataMotor[tabIndex]) {
                        newPositionDataMotor[tabIndex] = [];
                    }
                    newPositionDataMotor[tabIndex].push({
                        x,
                        y,
                        name,
                        width,
                        height,
                        tabIndex,
                        id,
                        deviceType,
                        on,
                        channelName,
                        zIndex,
                        hideChannel, hideValue
                    });
                }
            });
            setTabIndexMotor(newPositionDataMotor);
            setUpdatedTabIndexMotor(newPositionDataMotor);

            //For text

            const newPositionDataText = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    tabIndex,
                    id,
                    channelName,
                    text,
                    deviceType,
                    bgColor,
                    textColor,
                    fontSize,
                    alignHorizontally,
                    alignVertically,
                    zIndex,
                    isTransparent,
                    hideChannel, hideValue
                } = data;
                if (deviceType === "Text") {
                    if (!newPositionDataText[tabIndex]) {
                        newPositionDataText[tabIndex] = [];
                    }
                    newPositionDataText[tabIndex].push({
                        x,
                        y,
                        name,
                        channelName,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        bgColor,
                        textColor,
                        fontSize,
                        text,
                        alignHorizontally,
                        alignVertically,
                        zIndex,
                        isTransparent,
                        hideChannel, hideValue
                    });
                }
            });

            setTabIndexText(newPositionDataText);
            setUpdatedTabIndexText(newPositionDataText);

            //updating position of Line Chart
            const newPositionDataLineChart = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    hour,
                    minute,
                    zIndex,
                    lineStyle,
                    isCurveLine,
                    isSteppedLine,
                    minY,
                    maxY,
                    xInterval,
                    yInterval
                } = data;
                if (deviceType === "LineChart") {
                    if (!newPositionDataLineChart[tabIndex]) {
                        newPositionDataLineChart[tabIndex] = [];
                    }
                    newPositionDataLineChart[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        hour,
                        minute,
                        zIndex,
                        lineStyle,
                        isCurveLine,
                        isSteppedLine,
                        minY,
                        maxY,
                        xInterval,
                        yInterval
                    });
                }
            });
            setTabIndexLineChart(newPositionDataLineChart);
            setUpdatedTabIndexLineChart(newPositionDataLineChart);

            //Updating position of Pie chart
            const newPositionDataPieChart = {};

            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    zIndex
                } = data;
                if (deviceType === "PieChart") {
                    if (!newPositionDataPieChart[tabIndex]) {
                        newPositionDataPieChart[tabIndex] = [];
                    }
                    newPositionDataPieChart[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        zIndex
                    });
                }
            });

            setTabIndexPieChart(newPositionDataPieChart);
            setUpdatedTabIndexPieChart(newPositionDataPieChart);

            //Updating position of Bar chart
            const newPositionDataBarChart = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    zIndex
                } = data;
                if (deviceType === "BarChart") {
                    if (!newPositionDataBarChart[tabIndex]) {
                        newPositionDataBarChart[tabIndex] = [];
                    }
                    newPositionDataBarChart[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        zIndex
                    });
                }
            });

            setTabIndexBarChart(newPositionDataBarChart);
            setUpdatedTabIndexBarChart(newPositionDataBarChart);

            //Updating position of Histogram
            const newPositionDataHistogram = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    hour,
                    minute,
                    zIndex
                } = data;
                if (deviceType === "Histogram") {
                    if (!newPositionDataHistogram[tabIndex]) {
                        newPositionDataHistogram[tabIndex] = [];
                    }
                    newPositionDataHistogram[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        hour,
                        minute,
                        zIndex
                    });
                }
            });
            setTabIndexHistogram(newPositionDataHistogram);
            setUpdatedTabIndexHistogram(newPositionDataHistogram);

            //Updating position of Gauge
            const newPositionDataGauge = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    maxVal,
                    minVal,
                    width,
                    height,
                    fontSize,
                    zIndex
                } = data;
                if (deviceType === "Gauge") {
                    if (!newPositionDataGauge[tabIndex]) {
                        newPositionDataGauge[tabIndex] = [];
                    }
                    newPositionDataGauge[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        minVal,
                        maxVal,
                        width,
                        height,
                        fontSize,
                        zIndex
                    });
                }
            });
            setTabIndexGauge(newPositionDataGauge);
            setUpdatedTabIndexGauge(newPositionDataGauge);

            //Updating position of Progress Bar
            const newPositionDataProgress = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    maxVal,
                    minVal,
                    rotate,
                    width,
                    height,
                    fontSize,
                    bgColor,
                    zIndex
                } = data;
                if (deviceType === "ProgressBar") {
                    if (!newPositionDataProgress[tabIndex]) {
                        newPositionDataProgress[tabIndex] = [];
                    }
                    newPositionDataProgress[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        maxVal,
                        minVal,
                        rotate,
                        width,
                        height,
                        fontSize,
                        bgColor,
                        zIndex
                    });
                }
            });
            setTabIndexProgress(newPositionDataProgress);
            setUpdatedTabIndexProgress(newPositionDataProgress);

            //Updating position of Grid
            const newPositionDataGrid = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    width,
                    height,
                    zIndex
                } = data;
                if (deviceType === "Grid") {
                    if (!newPositionDataGrid[tabIndex]) {
                        newPositionDataGrid[tabIndex] = [];
                    }
                    newPositionDataGrid[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        zIndex
                    });
                }
            });
            setTabIndexGrid(newPositionDataGrid);
            setUpdatedTabIndexGrid(newPositionDataGrid);

            const newPositionDataTable = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    width,
                    height,
                    column,
                    zIndex
                } = data;
                if (deviceType === "Table") {
                    if (!newPositionDataTable[tabIndex]) {
                        newPositionDataTable[tabIndex] = [];
                    }
                    newPositionDataTable[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        column,
                        zIndex
                    });
                }
            });
            setTabIndexTable(newPositionDataTable);
            setUpdatedTabIndexTable(newPositionDataTable);



            //Updating position of Pie chart
            const newPositionDataDoughnut = {};

            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    zIndex
                } = data;
                if (deviceType === "Doughnut") {
                    if (!newPositionDataDoughnut[tabIndex]) {
                        newPositionDataDoughnut[tabIndex] = [];
                    }
                    newPositionDataDoughnut[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        zIndex
                    });
                }
            });

            setTabIndexDoughnut(newPositionDataDoughnut);
            setUpdatedTabIndexDoughnut(newPositionDataDoughnut);


            const newPositionDatLines = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    name,
                    tabIndex,
                    id,
                    deviceType,
                    width,
                    height,
                    length,
                    deltaX,
                    deltaY,
                    angle,
                    zIndex,
                    hideValue,
                    hideChannel,
                    bgColor,
                    moveValue,
                    conditionValue,
                    horizontalMoveChannel,
                    verticalMoveChannel
                } = data;
                if (deviceType === "Line") {
                    if (!newPositionDatLines[tabIndex]) {
                        newPositionDatLines[tabIndex] = [];
                    }
                    newPositionDatLines[tabIndex].push({
                        x,
                        y,
                        name,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        length,
                        deltaX,
                        deltaY,
                        angle,
                        zIndex,
                        hideValue,
                        hideChannel,
                        bgColor,
                        moveValue,
                        conditionValue,
                        horizontalMoveChannel,
                        verticalMoveChannel
                    });
                }
            });
            setTabIndexLines(newPositionDatLines);
            setUpdatedTabIndexLines(newPositionDatLines);


            const newPositionDataSquare = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    deviceType,
                    tabIndex,
                    id,
                    bgColor,
                    onText,
                    offText,
                    onColor,
                    offColor,
                    fontSize,
                    text,
                    textColor,
                    hideChannel,
                    hideValue,
                    conditionValue,
                    moveValue,
                    horizontalMoveChannel,
                    verticalMoveChannel,
                    zIndex
                } = data;
                if (deviceType === "Square") {
                    if (!newPositionDataSquare[tabIndex]) {
                        newPositionDataSquare[tabIndex] = [];
                    }
                    newPositionDataSquare[tabIndex].push({
                        x,
                        y,
                        name,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        bgColor,
                        onText,
                        offText,
                        onColor,
                        offColor,
                        fontSize,
                        text,
                        textColor,
                        hideChannel,
                        hideValue,
                        conditionValue,
                        moveValue,
                        horizontalMoveChannel,
                        verticalMoveChannel,
                        zIndex
                    });
                }
            });

            setTabIndexSquare(newPositionDataSquare);
            setUpdatedTabIndexSquare(newPositionDataSquare);


            const newPositionDataCircle = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    deviceType,
                    tabIndex,
                    id,
                    bgColor,
                    onText,
                    offText,
                    onColor,
                    offColor,
                    text,
                    fontSize,
                    channelName,
                    textColor,
                    hideChannel,
                    hideValue,
                    conditionValue,
                    moveValue,
                    horizontalMoveChannel,
                    verticalMoveChannel,
                    zIndex,
                } = data;
                if (deviceType === "Circle") {
                    if (!newPositionDataCircle[tabIndex]) {
                        newPositionDataCircle[tabIndex] = [];
                    }
                    newPositionDataCircle[tabIndex].push({
                        x,
                        y,
                        name,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        bgColor,
                        onText,
                        offText,
                        onColor,
                        offColor,
                        text,
                        fontSize,
                        channelName,
                        textColor,
                        hideChannel,
                        hideValue,
                        conditionValue,
                        moveValue,
                        horizontalMoveChannel,
                        verticalMoveChannel,
                        zIndex,
                    });
                }
            });

            setTabIndexCircle(newPositionDataCircle);
            setUpdatedTabIndexCircle(newPositionDataCircle);

            const newPositionDataPolygone = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    deviceType,
                    tabIndex,
                    id,
                    bgColor,
                    points,
                    hideChannel, hideValue,
                    zIndex
                } = data;
                if (deviceType === "Polygone") {
                    if (!newPositionDataPolygone[tabIndex]) {
                        newPositionDataPolygone[tabIndex] = [];
                    }
                    newPositionDataPolygone[tabIndex].push({
                        x,
                        y,
                        name,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        bgColor,
                        points,
                        zIndex,
                        hideChannel, hideValue
                    });
                }
            });

            setTabIndexPolygone(newPositionDataPolygone);
            setUpdatedTabIndexPolygone(newPositionDataPolygone);


            const newPositionDataPipe = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    deviceType,
                    tabIndex,
                    id,
                    points,
                    bgColor,
                    textColor,
                    channelName,
                    hideChannel, hideValue,
                    zIndex
                } = data;
                if (deviceType === "Pipe") {
                    if (!newPositionDataPipe[tabIndex]) {
                        newPositionDataPipe[tabIndex] = [];
                    }
                    newPositionDataPipe[tabIndex].push({
                        x,
                        y,
                        name,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        points,
                        zIndex,
                        bgColor,
                        channelName,
                        textColor,
                        hideChannel, hideValue
                    });
                }
            });

            setTabIndexPipe(newPositionDataPipe);
            setUpdatedTabIndexPipe(newPositionDataPipe);



            const newPositionDataCircularProgress = {};
            tempImages.forEach((data, index) => {
                const { x, y, tabIndex, name, id, width, height, chartChannel, maxVal, zIndex } = data;
                if (name === "CircularProgress") {
                    if (!newPositionDataCircularProgress[tabIndex]) {
                        newPositionDataCircularProgress[tabIndex] = [];
                    }
                    newPositionDataCircularProgress[tabIndex].push({
                        x,
                        y,
                        tabIndex,
                        id,
                        width,
                        height,
                        name,
                        chartChannel,
                        maxVal,
                        zIndex,

                    });
                }
            });
            setTabIndexCircularProgress(newPositionDataCircularProgress);


            const newPositionDataSwitch = {};
            tempImages.forEach((data, index) => {
                const { x, y, name, tabIndex, id, on, deviceType, zIndex, hideChannel, hideValue, bgColor } = data;
                if (deviceType === "Switch") {
                    if (!newPositionDataSwitch[tabIndex]) {
                        newPositionDataSwitch[tabIndex] = [];
                    }
                    newPositionDataSwitch[tabIndex].push({

                        x,
                        y,
                        name,
                        on,
                        tabIndex,
                        id,
                        deviceType,
                        hideChannel, hideValue,
                        bgColor,
                        zIndex
                    });
                }
            });

            setTabIndexSwitch(newPositionDataSwitch);
            setUpdatedTabIndexSwitch(newPositionDataSwitch);

            const newPositionDataCheckbox = {};
            tempImages.forEach((data, index) => {
                const { x, y, name, tabIndex, id, deviceType, width, height, on, zIndex, hideChannel, hideValue } = data;
                if (deviceType === "Checkbox") {
                    if (!newPositionDataCheckbox[tabIndex]) {
                        newPositionDataCheckbox[tabIndex] = [];
                    }
                    newPositionDataCheckbox[tabIndex].push({

                        x,
                        y,
                        name,
                        on,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        zIndex, hideChannel, hideValue
                    });
                }
            });

            setTabIndexCheckbox(newPositionDataCheckbox);
            setUpdatedTabIndexCheckbox(newPositionDataCheckbox);


            const newPositionDataRadio = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    deviceType,
                    tabIndex,
                    id,
                    points,
                    selectedIndex,
                    zIndex, hideChannel, hideValue
                } = data;
                if (deviceType === "Radio") {
                    if (!newPositionDataRadio[tabIndex]) {
                        newPositionDataRadio[tabIndex] = [];
                    }
                    newPositionDataRadio[tabIndex].push({
                        x,
                        y,
                        name,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        points,
                        selectedIndex,
                        zIndex, hideChannel, hideValue
                    });
                }
            });

            setTabIndexRadio(newPositionDataRadio);
            setUpdatedTabIndexRadio(newPositionDataRadio);


            //Updating position of Progress Bar
            const newPositionDataSlider = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    maxVal,
                    minVal,
                    width,
                    height,
                    bgColor,
                    fontSize,
                    textColor,
                    zIndex, hideChannel, hideValue
                } = data;
                if (deviceType === "Slider") {
                    if (!newPositionDataSlider[tabIndex]) {
                        newPositionDataSlider[tabIndex] = [];
                    }
                    newPositionDataSlider[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        maxVal,
                        minVal,
                        width,
                        height,
                        bgColor,
                        fontSize,
                        textColor,
                        zIndex, hideChannel, hideValue
                    });
                }
            });
            setTabIndexSlider(newPositionDataSlider);
            setUpdatedTabIndexSlider(newPositionDataSlider);


            //Updating position of Progress Bar
            const newPositionDataLamp = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    width,
                    height,
                    zIndex, hideChannel, hideValue
                } = data;
                if (deviceType === "Lamp") {
                    if (!newPositionDataLamp[tabIndex]) {
                        newPositionDataLamp[tabIndex] = [];
                    }
                    newPositionDataLamp[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        zIndex, hideChannel, hideValue
                    });
                }
            });
            setTabIndexLamp(newPositionDataLamp);
            setUpdatedTabIndexLamp(newPositionDataLamp);


            //Updating position of Progress Bar
            const newPositionDataPush = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    name,
                    tabIndex,
                    id,
                    chartChannel,
                    deviceType,
                    width,
                    height,
                    zIndex, hideChannel, hideValue
                } = data;
                if (deviceType === "Push") {
                    if (!newPositionDataPush[tabIndex]) {
                        newPositionDataPush[tabIndex] = [];
                    }
                    newPositionDataPush[tabIndex].push({
                        x,
                        y,
                        name,
                        chartChannel,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        zIndex, hideChannel, hideValue
                    });
                }
            });
            setTabIndexPush(newPositionDataPush);
            setUpdatedTabIndexPush(newPositionDataPush);


            //For Link

            const newPositionDataLink = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    tabIndex,
                    id,
                    channelName,
                    text,
                    deviceType,
                    bgColor,
                    textColor,
                    fontSize,
                    alignHorizontally,
                    alignVertically,
                    zIndex, hideChannel, hideValue
                } = data;
                if (deviceType === "Link") {
                    if (!newPositionDataLink[tabIndex]) {
                        newPositionDataLink[tabIndex] = [];
                    }
                    newPositionDataLink[tabIndex].push({
                        x,
                        y,
                        name,
                        channelName,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        bgColor,
                        textColor,
                        fontSize,
                        text,
                        alignHorizontally,
                        alignVertically,
                        zIndex, hideChannel, hideValue
                    });
                }
            });

            setTabIndexLink(newPositionDataLink);
            setUpdatedTabIndexLink(newPositionDataLink);

            const newPositionDataClock = {};
            tempImages.forEach((data, index) => {
                const {
                    x,
                    y,
                    width,
                    height,
                    name,
                    deviceType,
                    tabIndex,
                    id,
                    fontSize,
                    zIndex, hideChannel, hideValue

                } = data;
                if (deviceType === "Clock") {
                    if (!newPositionDataClock[tabIndex]) {
                        newPositionDataClock[tabIndex] = [];
                    }
                    newPositionDataClock[tabIndex].push({
                        x,
                        y,
                        name,
                        tabIndex,
                        id,
                        deviceType,
                        width,
                        height,
                        fontSize,
                        zIndex, hideChannel, hideValue

                    });
                }
            });

            setTabIndexClock(newPositionDataClock);
            setUpdatedTabIndexClock(newPositionDataClock);

            const newPositionDataOverviewGraph = {};
            tempImages.forEach((data, index) => {
                const { x, y, name, tabIndex, id, width, height } = data;
                if (name === "overviewGraph") {
                    if (!newPositionDataOverviewGraph[tabIndex]) {
                        newPositionDataOverviewGraph[tabIndex] = [];
                    }
                    newPositionDataOverviewGraph[tabIndex].push({
                        x,
                        y,
                        tabIndex,
                        id,
                        name,
                        width,
                        height,
                    });
                }
            });

            setTabIndexOverviewGraph(newPositionDataOverviewGraph);

            const newPositionDataOverviewInfo = {};

            tempImages.forEach((data, index) => {
                const { x, y, name, tabIndex, id, width, height } = data;
                if (name === "overviewInfo") {
                    if (!newPositionDataOverviewInfo[tabIndex]) {
                        newPositionDataOverviewInfo[tabIndex] = [];
                    }
                    newPositionDataOverviewInfo[tabIndex].push({
                        x,
                        y,
                        tabIndex,
                        id,
                        name,
                        width,
                        height,
                    });
                }
            });
            setTabIndexOverviewInfo(newPositionDataOverviewInfo);

            const newPositionDataLiveDataGraph = {};
            tempImages.forEach((data, index) => {
                const { x, y, tabIndex, name, id, width, height } = data;
                if (name === "liveDataGraph") {
                    if (!newPositionDataLiveDataGraph[tabIndex]) {
                        newPositionDataLiveDataGraph[tabIndex] = [];
                    }
                    newPositionDataLiveDataGraph[tabIndex].push({
                        x,
                        y,
                        tabIndex,
                        id,
                        width,
                        height,
                        name,
                    });
                }
            });
            setTabIndexLiveDataGraph(newPositionDataLiveDataGraph);

            const newPositionDataLastDayTable = {};
            tempImages.forEach((data, index) => {
                const { x, y, tabIndex, name, id, width, height } = data;
                if (name === "lastDayTable") {
                    if (!newPositionDataLastDayTable[tabIndex]) {
                        newPositionDataLastDayTable[tabIndex] = [];
                    }
                    newPositionDataLastDayTable[tabIndex].push({
                        x,
                        y,
                        tabIndex,
                        id,
                        width,
                        height,
                        name,
                    });
                }
            });
            setTabIndexLastDayTable(newPositionDataLastDayTable);

            const newPositionDataLastDayGraph = {};
            tempImages.forEach((data, index) => {
                const { x, y, tabIndex, name, id, width, height } = data;
                if (name === "lastDayGraph") {
                    if (!newPositionDataLastDayGraph[tabIndex]) {
                        newPositionDataLastDayGraph[tabIndex] = [];
                    }
                    newPositionDataLastDayGraph[tabIndex].push({
                        x,
                        y,
                        tabIndex,
                        id,
                        width,
                        height,
                        name,
                    });
                }
            });
            setTabIndexLastDayGraph(newPositionDataLastDayGraph);

            const newPositionDataDefaultGrid = {};
            tempImages.forEach((data, index) => {
                const { x, y, tabIndex, name, id, width, height } = data;
                if (name === "DefaultGrid") {
                    if (!newPositionDataDefaultGrid[tabIndex]) {
                        newPositionDataDefaultGrid[tabIndex] = [];
                    }
                    newPositionDataDefaultGrid[tabIndex].push({
                        x,
                        y,
                        tabIndex,
                        id,
                        width,
                        height,
                        name,
                    });
                }
            });
            setTabIndexDefaultGrid(newPositionDataDefaultGrid);

        }



    });

}; 